import Vue from 'vue'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import defaultLanguagesTrad from '@/locale/lang/en'
export const defaultLocale = 'en'

const prod = true // process.env.NODE_ENV === 'production'

Vue.use(VueI18n)

export const locales = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr'
  },
  {
    code: 'fr',
    name: 'Francais',
    dir: 'ltr'
  }
]

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: defaultLocale, // set locale
  fallbackLocale: 'en',
  silentTranslationWarn:prod,
  silentFallbackWarn:prod,
  messages:{
    [defaultLocale]:defaultLanguagesTrad
  }, // set locale messages
})

const loadedLanguages = [defaultLocale] // our default language that is preloaded 

function setI18nLanguage(lang:string) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html')!.setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang:string) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/locale/lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    } 
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}